import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/img/back_arrow.svg'
import _imports_1 from '@/assets/img/logo.svg'
import _imports_2 from '@/assets/img/users.svg'
import _imports_3 from '@/assets/img/logout.svg'


const _hoisted_1 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_2 = { class: "imageContainer" }
const _hoisted_3 = {
  key: 1,
  src: _imports_1
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "username" }, "Superadmin", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "role" }, "Settings", -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { class: "username" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "role" }, "Logout", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "logout me-2" }, "Users", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "logout me-2" }, "Logout", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1)
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["boxContainer accountBox", {'opened': _ctx.optionsMenuOpened}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.optionsMenuOpened)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _imports_0,
              class: "pointer",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleMenu()))
            }))
          : (_openBlock(), _createElementBlock("img", _hoisted_3))
      ]),
      (_ctx.isAdmin)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "text-end pointer",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleMenu()))
          }, _hoisted_6))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "text-end pointer",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.logout()))
          }, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.loggedUser.username), 1),
            _hoisted_8
          ]))
    ]),
    _createElementVNode("div", {
      class: "d-flex align-items-center justify-content-end mt-5 pointer",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/users')))
    }, _hoisted_11),
    _createElementVNode("div", {
      class: "d-flex align-items-center justify-content-end mt-4 pointer",
      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.logout()))
    }, _hoisted_14)
  ], 2))
}